export const mutations = {
  STORE_PETTYCASHES(state, pettycashes) {
    state.pettycashes = pettycashes;
  },
  STORE_PETTY(state, pettycash) {
    state.pettycash = pettycash;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettycashes/mutations.js